import { ToothMascot } from "./ToothMascot";

export const PageHeader = ({ eyebrow, title, text, testid }) => (
  <section className="relative overflow-hidden border-b border-teal-100 dot-bg" data-testid={testid}>
    <div className="absolute -right-16 -top-10 h-64 w-64 rounded-full bg-[#fef3c7] blur-3xl" />
    <div className="relative mx-auto flex max-w-7xl items-center gap-6 px-5 py-10 sm:px-6 sm:py-14 lg:px-8">
      <div className="flex-1">
        <span className="text-xs font-bold uppercase tracking-widest text-teal-600">{eyebrow}</span>
        <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
        {text && <p className="mt-4 max-w-2xl text-base text-slate-600 md:text-lg">{text}</p>}
      </div>
      <ToothMascot className="animate-floaty hidden w-28 sm:block" />
    </div>
  </section>
);
